export function getAiPromptType(_carrier: string, productName: string, isJoint: boolean): string | null {
  const product = productName?.toLowerCase().replace(/[®™©]/g, '').trim() || '';

  if (product.includes('carematters')) {
    return isJoint ? 'underwriting-nw-partner-guidance' : 'underwriting-nw-guidance';
  }

  if (product.includes('asset care')) {
    return isJoint ? 'underwriting-oa-partner-guidance' : 'underwriting-oa-guidance';
  }

  if (product.includes('carescout')) {
    return 'underwriting-cs-guidance';
  }

  if (product.includes('lincoln')) {
    return 'underwriting-lincoln-guidance';
  }

  return null;
}